import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import {
  createContext,
  type PropsWithChildren,
  useMemo,
  useContext
} from 'react';
import type { RecentSearch } from '~/contracts/home';

export type RecentSearchesContextType = {
  recentSearches: LoadableState<RecentSearch[]>;
};

export const defaultRecentSearchesContext: RecentSearchesContextType = {
  recentSearches: defaultLoadableState<RecentSearch[]>([])
};

const RecentSearchesContext = createContext<RecentSearchesContextType>(
  defaultRecentSearchesContext
);

export type OwnProps = PropsWithChildren<{
  recentSearches: RecentSearch[];
}>;

export function RecentSearchesContextProvider(props: OwnProps) {
  const recentSearches = useLoadableState<RecentSearch[]>(props.recentSearches);

  const value = useMemo<RecentSearchesContextType>(
    () => ({
      recentSearches
    }),
    [recentSearches]
  );

  return (
    <RecentSearchesContext.Provider value={value}>
      {props.children}
    </RecentSearchesContext.Provider>
  );
}

RecentSearchesContextProvider.displayName = 'RecentSearchesContextProvider';

export function useGetRecentSearches(): RecentSearch[] {
  return useContext(RecentSearchesContext).recentSearches.data;
}

export default RecentSearchesContext;
